export interface ActivityPhoto {
  id: number;
  path: string;
}

export interface ItineraryStep {
  time: string;
  label: string;
}

export interface ActivityFormData {
  name: string;
  description: string;
  price: string;
  inclusions: string[];
  itinerary: ItineraryStep[];
}

export const EMPTY_ACTIVITY_FORM: ActivityFormData = {
  name: "",
  description: "",
  price: "",
  inclusions: [],
  itinerary: [],
};